import React from "react";
import clsx from "clsx";

interface AppLoaderProps {
  color?: "primary" | "secondary" | "white"; // Define color options
  size?: number; // Size of the loader in pixels
}

const AppLoader: React.FC<AppLoaderProps> = ({
  color = "secondary",
  size = 40,
}) => {
  const loaderClasses = clsx(
    "inline-block animate-spin rounded-full border-4",
    {
      "border-t-primary border-primary/20": color === "primary",
      "border-t-secondary border-secondary/20": color === "secondary",
      "border-t-white border-white/20": color === "white",
    }
  );

  return (
    <div
      className={loaderClasses}
      style={{
        width: `${size}px`,
        height: `${size}px`,
      }}
    />
  );
};

export default AppLoader;